import api from './api';

export const CreateBlogDirectory = async (folder) => {
        let resposta = await api.post(`CreateBlogDirectory?Folder=${folder}`).then((response)=>{
            let folder = response;
             return folder;
        }).catch((error)=>{

                return error;

        });

        return resposta;

};
